module.exports = __webpack_public_path__ + "static/about-us-founder-photo@2x-fd636d7f9bcf2844d75d27d437127af8.jpg";